import { c as _c } from "react/compiler-runtime";
import { cloneElement, type ReactElement, type ReactNode, type Ref } from 'react';
interface WrapperProps {
  component?: ReactElement;
  children: ReactNode;
  ref?: Ref<HTMLElement>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- passthrough prop bag forwarded verbatim to cloneElement, which can't type a dynamic element's props
  [key: string]: any;
}
export const Wrapper = t0 => {
  const $ = _c(5);
  let t1;
  let t2;
  if ($[0] !== t0) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        component,
        children,
        ...rest
      } = t0;
      if (!component) {
        let t3;
        if ($[3] !== children) {
          t3 = <>{children}</>;
          $[3] = children;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        t2 = t3;
        break bb0;
      }
      t1 = cloneElement(component, rest, children);
    }
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
};
Wrapper.displayName = 'Wrapper';